export class Deferred<T> {

    promise: Promise<T>;
    resolve: (value?: T | PromiseLike<T>) => void;
    reject: (reason?: any) => void;

    constructor() {
        this.promise = new Promise<T>((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}


// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/shared/Deferred.ts